var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();}}},[_c('img',{staticClass:"rule",attrs:{"src":"https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/936717c4c8f5fd3fee5294988fd4a2f5.png","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }